<script setup>
import { entityRegistry } from '@/config/entityRegistry'
import DynamicField from '@/components/reusable/DynamicField.vue'
import { provide , onMounted, ref, watch} from "vue"
import { resetPassword } from '@/services/entityService'
import { usePathController } from '@/composables/usePathController'
import { useUserStore} from '@/store/user'
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger() 
const userStore = useUserStore()
const props = defineProps({
  entityType: String,
  modelValue: Object,
  editorMode: String,
  itemName: String
})

function setNestedValue(obj, keys, value) {
  return keys.reduce((acc, key, index) => {
    if (index === keys?.length - 1) {
      acc[key] = value;
    } else {
      acc[key] = acc[key] || {};
    }
    return acc[key];
  }, obj);
}

provide("updateNestedValue", (path, value) => {
  sendLog("debug", "updateNestedValue", props.modelValue)
  setNestedValue(props.modelValue, path, value)
})

provide("updatePassword", async (password) => {
  await resetPassword(password, props.modelValue.email)
})

provide("updateEntity", (key, value) => {
  sendLog("debug", "updateEntity", { key, value})
  props.modelValue[key] = value
})

provide("resetEntity", (key) => {
  props.modelValue[key] = null
})

provide("removeEntityField", (key) => {
  delete props.modelValue[key] 
})

provide("entityState", props.modelValue)

const fieldComponentMap = {
  text: 'v-text-field',
  password: 'v-text-field',
  number: 'v-text-field',
  textarea: 'v-textarea',
  boolean: 'v-switch',
  select: 'v-select',
  multiselect: 'v-select',
  date: 'v-date-input',

}
const groups = entityRegistry[props.entityType].groups

function shouldShowField(field) {
  if (props.editorMode === 'edit') {
    return !field.showIf || field.showIf(props.modelValue, userStore.accesslevel)
  }
  return field.requiredForCreation
}

function getFieldValue(field) {
  return props.modelValue[field.key]
}

function ensureFieldValue(field) {
  sendLog("debug", "ensureFieldValue", field)
  if (props.modelValue[field.key] != null){
    return
  } 
  if (field.key === 'roles') {
    props.modelValue[field.key] = []
  } else {
    props.modelValue[field.key] = ''
  }
}

const getFieldProps = (field) => {
  switch (field.type) {
    case 'select':
      return {
        items: field.items,
        itemTitle: 'label',
        itemValue: 'value'
      }

    case 'number':
      return {
        type: 'number'
      }

    case 'password':
      return {
        type: 'password'
      }

    case 'boolean':
      return {
        inset: true
      }

    default:
      return {}
  }
}

watch(
  () => props.entityType,
  (type) => {
    const groups = entityRegistry[type]?.groups || []
    groups.forEach(group => {
      group.fields.forEach(ensureFieldValue)
    })
  },
  { immediate: true }
)

</script>

<template>
  <v-container fluid>

  <template v-for="group in groups">

    <v-card class="mb-12">
      <v-card-title>{{ group.title }}</v-card-title>
      <v-card-text>
      <v-row>
        <template v-for="field in group.fields" :key="field.key">
            <v-col
              v-if="shouldShowField(field)"
              cols="12"
              md="12"
            >
              <DynamicField
                :field="field"
                :model-value="getFieldValue(field)"
                :drawerMode="editorMode"
                :path="[field.key]"
                :itemName="itemName"
              />
            </v-col>
        </template>
      </v-row>
    </v-card-text>
    </v-card>

  </template>

</v-container>
</template>
